import React from "react";
import { Text, View, StyleSheet } from "@react-pdf/renderer";

const styles = StyleSheet.create({
  headerContainer: {
    marginTop: 0,
  },

  lineContainer: {
    flexDirection: "row",
    marginTop: 1,
  },
  enterprise: {
    width: "80%",
    fontSize: 12,
  },
  ruc: {
    fontSize: 12,
    fontFamily: "Helvetica-Bold",
  },
});

const EnterpriseData = ({ selectEnterprise }) => (
  <View>
    <View style={styles.lineContainer}>
      <Text style={styles.enterprise}>
        <Text style={{ fontFamily: "Helvetica-Bold" }}>Empresa: </Text>
        {selectEnterprise.commertial_name}
      </Text>
      <Text>
        <Text style={styles.ruc}>RUC: </Text>
        {selectEnterprise.ruc}
      </Text>
    </View>
  </View>
);

export default EnterpriseData;
